import React from 'react';

import { ValueType } from 'react-select/lib/types';
import { HttpStatusCodeItem, httpStatusCodesGrouped } from 'utils/httpStatusCodes';
import BzSelect, { OptionTypeBase } from 'components/forms/BzSelect';

interface StatusCodeSelectProps {
  selectedStatus: HttpStatusCodeItem;
  onSelect: (status: HttpStatusCodeItem) => void;
  id: string;
  isReadOnly?: boolean;
}

const StatusCodeSelect = (props: StatusCodeSelectProps) => {
  const handleChange = (value: ValueType<OptionTypeBase>) => {
    props.onSelect(value as HttpStatusCodeItem);
  };

  return (
    <BzSelect
      isDisabled={props.isReadOnly}
      value={props.selectedStatus}
      name="form-field-name"
      onChange={handleChange}
      options={httpStatusCodesGrouped}
      id={props.id}
    />
  );
};

export default StatusCodeSelect;
